import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Box, ICommand, Label, formatDate } from "Application";
import { CellContext, ColumnDef } from "@tanstack/react-table";
import { DataTable } from "Components/Primitives/DataTable";
import { CancelSVG } from "Assets/Icons/Cancel";
import styled from "@emotion/styled";
import { DownloadIcon } from "Assets/Icons/DownloadIcon";
import { isNullOrUndefined } from "@shoothill/core";
import { StudentSessionAQACertificateViewModel } from "./StudentSessionAQACertificateViewModel";

interface IProps {
    onRemoveRowCommand: ICommand;
    onRowEditCommand: ICommand;
    data: StudentSessionAQACertificateViewModel[];
}

//todo this should be passed as a system of prop to the table column definitions and not forced with CSS hackery

const TableWrapper = styled.div`
    background-color: white;

    overflow: auto;
    .mainTable {
        & > div {
            &:first-child {
                background: #f3f3f3;
                margin-bottom: 15px;
                & > div {
                    grid-template-columns: 1fr 60px !important;
                    & > div:not(:last-child) {
                        border-right: 1px solid #fff;
                    }
                    & > div {
                        @media only screen and (max-width: 767px) {
                            min-width: 180px;
                            &:last-child {
                                min-width: 70px;
                            }
                        }
                    }
                }
            }
            & > div {
                grid-template-columns: 9fr 60px !important;
                &:nth-of-type(even) {
                    background: #f9f9f9;
                }
                & > div {
                    @media only screen and (max-width: 767px) {
                        min-width: 180px;
                        &:last-child {
                            min-width: 70px;
                        }
                    }
                }
                & > div {
                    width: 100%;
                    box-sizing: border-box;

                    &:last-child {
                        border-right: none;
                    }
                }
            }
        }
        .justifyCenter {
            > div {
                justify-content: center;
            }
        }
        #lastAction {
            justify-content: flex-end;
        }
    }
`;

export const StudentSessionAQACertificateTableView: React.FC<IProps> = observer(({ data, onRemoveRowCommand, onRowEditCommand }) => {
    const onRowRemove = (row: StudentSessionAQACertificateViewModel) => {
        onRemoveRowCommand.execute(row);
    };
    const defaultColumns = () => [
        {
            header: " ",
            columns: [
                {
                    accessorKey: "description",
                    header: () => <Label fontStyle="h4">Description</Label>,
                    cell: (props: CellContext<StudentSessionAQACertificateViewModel, StudentSessionAQACertificateViewModel>) => <Label>{props.row.original.description}</Label>,
                },

                {
                    accessorKey: "actions",
                    header: () => <Label fontStyle="h4"></Label>,
                    enableSorting: false,
                    cell: (props: CellContext<any, StudentSessionAQACertificateViewModel>) => (
                        <Box
                            flexBox
                            justifyContent={"center"}
                            alignContent={"center"}
                            width={"100%"}
                            style={{ cursor: "pointer" }}
                            onClick={(e: any) => {
                                e.stopPropagation();
                                onRowRemove(props.row.original);
                            }}
                        >
                            <CancelSVG />
                        </Box>
                    ),
                },
            ],
        },
    ];

    return (
        <TableWrapper>
            <DataTable data={data} columns={defaultColumns()} rowClickCommand={onRowEditCommand} showSearchBox={false} />
        </TableWrapper>
    );
});
